function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-white-mini-map{fill:#fff;}.cls-boundary-color{fill:#39474f;}.light-grey{fill:#d0d0cd;}.green_dot{fill:#06a239;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "map");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-white-mini-map",
  x: 0.4,
  y: 0.5,
  width: 31.7,
  height: 15.4
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-boundary-color",
  d: "M31.7,1V15.4H1V1H31.7m1-1H0V16.4H32.7V0Z"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "map_perimeter"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 2.4,
  y: 9.6,
  width: 3.9,
  height: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 4.4,
  cy: 10.8,
  r: 0.7
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "map_gatehouse"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 6.7,
  y: 9.6,
  width: 3.9,
  height: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 8.7,
  cy: 10.8,
  r: 0.7
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  className: "map_exterior_front"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 11.1,
  y: 9.6,
  width: 3.9,
  height: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 13,
  cy: 10.8,
  r: 0.7
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  className: "map_reception"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 15.4,
  y: 9.6,
  width: 3.9,
  height: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 17.4,
  cy: 10.8,
  r: 0.7
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  className: "map_meeting_room"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 22.1,
  y: 9.6,
  width: 3.9,
  height: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 24.1,
  cy: 10.8,
  r: 0.7
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  className: "map_garage"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 15.4,
  y: 12.4,
  width: 3.9,
  height: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 17.4,
  cy: 13.6,
  r: 0.7
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  className: "map_basement"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 22.1,
  y: 12.4,
  width: 3.9,
  height: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 24.1,
  cy: 13.6,
  r: 0.7
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  className: "map_office"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 15.4,
  y: 6.9,
  width: 3.9,
  height: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 17.4,
  cy: 8.1,
  r: 0.7
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  className: "map_kitchen"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 22.1,
  y: 6.9,
  width: 3.9,
  height: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 24.1,
  cy: 8.1,
  r: 0.7
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  className: "map_ambassadors_office"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 15.4,
  y: 4.1,
  width: 3.9,
  height: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 17.4,
  cy: 5.3,
  r: 0.7
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  className: "map_roof"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "light-grey",
  points: "15.4 3.7 26 3.7 24.1 1.7 17.4 1.7 15.4 3.7"
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 20.7,
  cy: 2.7,
  r: 0.7
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  className: "map_server_room"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 22.1,
  y: 4.1,
  width: 3.9,
  height: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 24.1,
  cy: 5.3,
  r: 0.7
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  className: "map_exterior_back"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 26.4,
  y: 9.6,
  width: 3.9,
  height: 2.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot current_room_indicator",
  cx: 28.4,
  cy: 10.8,
  r: 0.7
}));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  className: "map_lift"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey",
  x: 19.8,
  y: 4.1,
  width: 1.9,
  height: 10.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot",
  cx: 20.7,
  cy: 9.4,
  r: 0.7
}));

var SvgMap = function SvgMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rooms-history-map",
    "data-name": "Rooms history map",
    viewBox: "0 0 32.7 16.4",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map.2a8d4b5c.svg";
export { ForwardRef as ReactComponent };